module.exports = __webpack_public_path__ + "static/media/building.0abb66a9.png";